import React, { useState } from "react";
import "./EditOrganization.css";
import {
  Box,
  Button,
  Text,
  Layer,
  FormField,
  TextInput,
  Form,
  TextArea,
} from "grommet";
import { Mixpanel } from "../../../../../../util/Helper";
import { useStore } from "../../../../../../Hooks/useStore";
import createFlightService from "../Users/CreateFlight/create-flight.service";
import closeEditOrganizationbar from "../../../../../../assets/close_small.svg";
import createOrganizationService from "../Users/CreateOrganization/create-organization.service";
import { observer } from "mobx-react";
import { onCreateChatMessage } from "../../../../../../graphql/ChatMessage/subscriptions";
import { FormTrash } from "grommet-icons";

function EditOrganization() {
  const { rootStore } = useStore();
  const [user, setUser] = useState({});

  const [number, setnumber] = useState([]);

  async function getOrganizationresest() {
    try {
      rootStore.organizationStore.handleEditOrganizationbar(true);

      createFlightService
        .getOrganization(rootStore.organizationStore.getid)
        .then((organizationResponse) => {
          rootStore.organizationStore.handleid(organizationResponse.id);
          rootStore.organizationStore.handlelegalEntryName(
            organizationResponse.name
          );
          rootStore.organizationStore.handleAdress(
            organizationResponse.address
          );
          rootStore.organizationStore.handlePhoneNumber(
            organizationResponse.phoneNumbers
          );
          rootStore.organizationStore.handleEmail(organizationResponse.emails);

          rootStore.organizationStore.handleEditOrganizationbar(
            organizationResponse
          );
          setnumber(
            organizationResponse.phoneNumbers
          );
        });
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  }

  // alert(JSON.stringify(rootStore.organizationStore.getphoneNumber))

  const onFormSubmit = ({ value }) => {
    Mixpanel.track("web_add_organization_submit_click", {
      name: user?.username,
    });

    const { name, address } = value;

    if (rootStore.organizationStore.getphoneNumber.length == 0) {
      rootStore.notificationToastStore.showNotification("Please enter at least one number.", true);
      return;
    }
    if (rootStore.organizationStore.getEmail.length == 0) {
      rootStore.notificationToastStore.showNotification("Please enter at least one email.", true);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let a = 0;
    for (let email of rootStore.organizationStore.getEmail) {
      if (!emailRegex.test(email) && a == 0) {
        a++;
        rootStore.notificationToastStore.showNotification('Please enter valid email.', true);
        return;
      }
    }

    if (name == "") {
      rootStore.errorHandlingStore.displayError(
        "Invalid input, Please enter organization name."
      );
    } else {
      createOrganizationService
        .editOrganization(
          rootStore.organizationStore.getid,
          name,
          address,
          rootStore.organizationStore.getphoneNumber,
          rootStore.organizationStore.getEmail
        )
        .then(() => {
          rootStore.notificationToastStore.showNotification(
            "Successfully Update Organization",
            false,
            3000
          );
          rootStore.organizationStore.handleupdate();
        })
        .catch((e) => {
          rootStore.notificationToastStore.showNotification(
            "Failed to Update organization!",
            true,
            3000
          );
        });
    }
    handleClose();
  };

  const handleClose = () => {
    rootStore.organizationStore.handleEditOrganizationbar(false);
  };

  const handleEditOrgReset = () => {
    Mixpanel.track("web_add_organization_reset_click", {
      name: user?.username,
    });
    getOrganizationresest();
  };

  const addPhoneNumber = () => {
    rootStore.organizationStore.handlePhoneNumber([...rootStore.organizationStore.getphoneNumber, ""]);
  };

  // Function to handle deleting a phone number
  const deletePhoneNumber = (index) => {
    const updatedPhoneNumbers = rootStore.organizationStore.getphoneNumber.filter((_, i) => i !== index);
    rootStore.organizationStore.handlePhoneNumber(updatedPhoneNumbers);
  };

  // Function to handle add phone number value
  const addPhoneNumberValue = (value, index) => {
    const updatePhoneNumbers = [...rootStore.organizationStore.getphoneNumber];
    updatePhoneNumbers[index] = value;
    rootStore.organizationStore.handlePhoneNumber(updatePhoneNumbers);
  }

  // Function to handle adding email addresses
  const addEmail = () => {
    rootStore.organizationStore.handleEmail([...rootStore.organizationStore.getEmail, ""]);
  };

  // Function to handle deleting an email
  const deleteEmail = (index) => {
    const updatedEmails = rootStore.organizationStore.getEmail.filter((_, i) => i !== index);
    rootStore.organizationStore.handleEmail(updatedEmails);
  };

  // Function to handle add email value
  const addEmailValue = (value, index) => {
    const updatePhoneNumbers = [...rootStore.organizationStore.getEmail];
    updatePhoneNumbers[index] = value;
    rootStore.organizationStore.handleEmail(updatePhoneNumbers);
  }

  return (
    <>
      <Layer
        className="Edit-organization-container"
        full="vertical"
        position="right"
        style={{
          width: "500px",
          height: "100%",
          flexShrink: "0",
          borderRadius: "12px 0px 0px 12px",
          backGround: "#FFF",
        }}
        onClickOutside={() => {
          rootStore.organizationStore.handleEditOrganizationbar(false);
          handleClose();
        }}
        onEsc={() => {
          rootStore.organizationStore.handleEditOrganizationbar(false);
          handleClose();
        }}
      >
        <Box className="Edit-organization-modal">
          <Text className="Edit-organization-modal-test">
            Edit Organization
          </Text>
          <Button className="close-btn" onClick={handleClose}>
            <img
              src={closeEditOrganizationbar}
              style={{ width: 20, height: 20 }}
            />
            Close
          </Button>
        </Box>
        <Box className="Edit-organization-middle-modal">
          <Form validate="change" onSubmit={onFormSubmit}>
            <FormField
              style={{ borderBottom: "none" }}
              className="Edit-organization-form-F1"
              htmlFor="legalEntryName-id"
              name="name"
              validate={[
                {
                  regexp: /^[A-Za-z0-9 ]+$/,
                  message: "Legal Entry Name can only contain letters, numbers, and spaces.",
                },
              ]}
            >
              <label className="Edit-organization-modal-form-L1">
                Legal Entry Name
              </label>
              <TextInput
                className="Edit-organization-modal-form-I1"
                id="legalEntryName-id"
                name="name"
                maxLength={100}
                placeholder="Enter Here"
                value={rootStore.organizationStore.getlegalEntryName}
                onChange={(e) => {
                  rootStore.organizationStore.handlelegalEntryName(e.target.value);
                }}
              />
            </FormField>
            <FormField className="Edit-organization-form-F1">
              <label className="Edit-organization-modal-form-L1">Address</label>
              <TextInput
                className="Edit-organization-modal-form-I2"
                id="address-id"
                name="address"
                maxLength={100}
                placeholder="Enter Here"
                value={rootStore.organizationStore.getAddress}
                onChange={(e) => {
                  rootStore.organizationStore.handleAdress(e.target.value);
                }}
              />
            </FormField>
            <FormField
              style={{ borderBottom: "none !important" }}
              className="Edit-organization-form-F1"
            >
              <label className="Edit-organization-modal-form-L1">
                Phone Number
              </label>
              {
                // Check if phoneNumbers is an array and if it's not empty
                Array.isArray(rootStore.organizationStore.getphoneNumber) &&
                  rootStore.organizationStore.getphoneNumber?.length > 0
                  ? rootStore.organizationStore.getphoneNumber?.map((val, index) => {
                    return (
                      <div key={index} style={{ position: "relative", marginTop: index === 0 ? 0 : 10 }}>
                        <TextInput
                          key={index} // Always use a unique key when rendering a list
                          className="Edit-organization-modal-form-I3"
                          id={`phoneNumber-id-${index}`}
                          name="phoneNumber"
                          placeholder="Enter Here"
                          type="text"
                          value={val}
                          onChange={(e) => {
                            const { value } = e.target;
                            // Filter out non-digit characters
                            const numericValue = value.replace(/\D/g, "");
                            // Assuming you want to update the phone number at this index
                            addPhoneNumberValue(numericValue, index);
                          }}
                        />
                        <FormTrash
                          color="red"
                          className="delect-row"
                          onClick={() => deletePhoneNumber(index)}
                          style={{ position: "absolute", right: "10px", top: "25px", cursor: "pointer" }}
                        />
                      </div>
                    );
                  })
                  : // If phoneNumbers is empty or undefined, show one input field
                  [
                    <TextInput
                      key="defaultPhoneNumber"
                      className="Edit-organization-modal-form-I3"
                      id="phoneNumber-id-default"
                      name="phoneNumber"
                      placeholder="Enter Here"
                      type="text"
                      value=""
                      onChange={(e) => {
                        const { value } = e.target;
                        // Filter out non-digit characters
                        const numericValue = value.replace(/\D/g, "");
                        // Assuming you want to update the phone number at this index
                        addPhoneNumberValue(numericValue, 0);
                      }}
                    />
                  ]
              }
              <div className="add-icon-container">
                {/* Disable the "+" button if the phone number limit is reached */}
                {rootStore.organizationStore.getphoneNumber?.length < 10 ? (
                  <p className="add-row-btn" onClick={addPhoneNumber}>+</p>
                ) : (
                  <p
                    className="add-row-btn-disabled"
                    style={{ color: "gray", cursor: "not-allowed" }}
                  >
                    Max Reached
                  </p>
                )}
              </div>

            </FormField>
            <FormField
              className="Edit-organization-form-F1"
              name="email"
              htmlFor="emailinput-id"
              validate={[
                {
                  regexp: /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
                  message: "Invalid email format.",
                },
              ]}
            >
              <label className="Edit-organization-modal-form-L1">Email</label>

              {
                // Check if phoneNumbers is an array and if it's not empty
                Array.isArray(rootStore.organizationStore.getEmail) &&
                  rootStore.organizationStore.getEmail?.length > 0
                  ? rootStore.organizationStore.getEmail?.map((val, index) => {
                    return (
                      <div key={index} style={{ position: "relative", marginTop: index === 0 ? 0 : 10 }}>
                        <TextInput
                          className="Edit-organization-modal-form-I3"
                          id="email-id"
                          name="email"
                          maxLength={50}
                          placeholder="Enter here"
                          value={val}
                          onChange={(e) => {
                            addEmailValue(e.target.value, index);
                          }}
                        />
                        <FormTrash
                          color="red"
                          className="delect-row"
                          onClick={() => deleteEmail(index)}
                          style={{ position: "absolute", right: "10px", top: "25px", cursor: "pointer" }}
                        />
                      </div>
                    );
                  })
                  : // If phoneNumbers is empty or undefined, show one input field
                  [
                    <TextInput
                      className="Edit-organization-modal-form-I3"
                      id="email-id"
                      name="email"
                      placeholder="Enter here"
                      value={''}
                      onChange={(e) => {
                        addEmailValue(e.target.value, 0);
                      }}

                    />
                  ]
              }

              <div className="add-icon-container">
                {/* Disable the "+" button if the phone number limit is reached */}
                {rootStore.organizationStore.getEmail?.length < 10 ? (
                  <p className="add-row-btn" onClick={addEmail}>+</p>
                ) : (
                  <p
                    className="add-row-btn-disabled"
                    style={{ color: "gray", cursor: "not-allowed" }}
                  >
                    Max Reached
                  </p>
                )}
              </div>
              {/* <div className="add-icon-container">
  <p className="add-row-btn" onClick={addEmail}>+</p>
</div> */}

            </FormField>
            <Box
              className="Edit-organization-footer"
              pad="small"
              justify="end"
              direction="row"
              align="center"
            >
              <Button
                className="Edit-organization-footer-btn1"
                label="Reset"
                type="Reset"
                onClick={handleEditOrgReset}
              />
              <Button
                type="submit"
                className="Edit-organization-footer-btn2"
                label="Submit"
              />
            </Box>
          </Form>
        </Box>
      </Layer>
    </>
  );
}

export default observer(EditOrganization);
